module.exports = __webpack_public_path__ + "static/hero-landing-create-0243627c307cd9d0fc0b7d206f7d9d4d.png";